import { render } from "./Conversation.vue?vue&type=template&id=ba7d6b32&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=ba7d6b32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ba7d6b32"

export default script